import {scopedHandler} from 'utils/redux';
import ns from './namespace';
import initState from './state';
import * as actions from './actions';
import * as effects from './effects';
import {decorateHandler as lifecycle} from 'fragments/lifecycle';

const handler = scopedHandler(ns, (state = initState, fullState, {type, payload}) => {
	switch (type) {
		case actions.initialize.type: {
			return [state, effects.initialize()];
		}

		case actions.destroy.type: {
			return [initState, null];
		}

		case actions.getOrganizations.type: {
			return [{...state}, effects.getOrganizations()];
		}
		case actions._getOrganizations.type: {
			return [{...state, organizations: payload}, null];
		}

		case actions.getTeams.type: {
			return [state, effects.getTeams()];
		}
		case actions._getTeams.type: {
			return [
				{
					...state,
					teams: payload,
				},
				null,
			];
		}

		case actions.getCities.type: {
			return [state, effects.getCities()];
		}
		case actions._getCities.type: {
			return [
				{
					...state,
					cities: payload,
				},
				null,
			];
		}

		case actions.getEncounterables.type: {
			return [
				{
					...state,
					processing: true,
				},
				effects.getEncounterables(payload),
			];
		}

		case actions._getEncounterables.type: {
			return [
				{
					...state,
					processing: false,
					encounterables: payload,
				},
				null,
			];
		}

		case actions.getReasonMappings.type: {
			return [state, effects.getReasonMappings()];
		}
		case actions._setReasonMappings.type: {
			return [
				{
					...state,
					reasonMappings: payload,
				},
				null,
			];
		}

		default:
			return [state, null];
	}
});

export default lifecycle({
	namespace: ns,
	initializeType: actions.initialize.type,
	destroyType: actions.destroy.type,
})(handler);
